import React from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { BulkEditionMenu } from 'common/components';

const BulkOperationsCard = ({
    canModify,
    filterData,
    handleClickBulkItems,
    handleClickChangeStatus,
    handleClickReassignAdvisor,
    prefix,
    selectedBulkOption,
    selectionModel,
    setSelectedBulkOption,
    setSelectionModel,
}) => {
    const { t } = useTranslation();
    const isArchivedList = filterData?.status2 === 'archived';
    const callback = () => {
        setSelectedBulkOption('');
        setSelectionModel([]);
    };

    if (isEmpty(selectionModel) || !canModify) return null;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
            <BulkEditionMenu
                items={[
                    {
                        handleClick: () =>
                            handleClickBulkItems(
                                selectionModel,
                                true,
                                filterData,
                                callback,
                            ),
                        label: t('Archive'),
                        visible: !isArchivedList,
                    },
                    {
                        handleClick: () =>
                            handleClickBulkItems(
                                selectionModel,
                                false,
                                filterData,
                                callback,
                            ),
                        label: t('Unarchive'),
                        visible: isArchivedList,
                    },
                    {
                        label: t('Reassign executive'),
                        handleClick: () =>
                            handleClickReassignAdvisor(
                                selectionModel,
                                callback,
                            ),
                        visible: true,
                    },
                    {
                        label: t('Change status'),
                        handleClick: () =>
                            handleClickChangeStatus(selectionModel, callback),
                        visible: true,
                    },
                ]}
                prefix={prefix}
                selectedBulkOption={selectedBulkOption}
                setSelectionModel={setSelectionModel}
            />
        </Box>
    );
};

BulkOperationsCard.propTypes = {
    canModify: PropTypes.bool,
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleClickChangeStatus: PropTypes.func,
    handleClickReassignAdvisor: PropTypes.func,
    prefix: PropTypes.string,
    selectedBulkOption: PropTypes.string,
    selectionModel: PropTypes.array,
    setSelectedBulkOption: PropTypes.func,
    setSelectionModel: PropTypes.func,
};

export default BulkOperationsCard;
